import { render } from "./ManualPriorities.vue?vue&type=template&id=27caba0e&ts=true"
import script from "./ManualPriorities.vue?vue&type=script&lang=ts"
export * from "./ManualPriorities.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__